import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { Container, Row, Col, Text } from 'ui';
import BeigeHeader from 'ui/layouts/BeigeHeader';
import { childrenType } from 'utils/types';

import s from './BeigeHeaderContent.module.scss';

const cx = cn.bind(s);

const BeigeHeaderContent = ({
  title,
  mainText,
  children,
  className,
  hasTorn = true,
  hasCircles = true,
  headerInfoColProps = {},
  ...attrs
}) => (
  <BeigeHeader
    hasTorn={hasTorn}
    hasCircles={hasCircles}
    className={cx('header', className)}
    {...attrs}
  >
    <Container className={cx('container')}>
      <Row>
        <Col
          xs={12}
          md={{
            offset: 1,
            span: 10,
          }}
          lg={{
            offset: 2,
            span: 8,
          }}
          {...headerInfoColProps}
        >
          <h1 className={cx('title', 'tp-mobile-header-1 md:tp-tablet-header-1 xl:tp-header-1')}>
            {title}
          </h1>
          {mainText && <Text className={cx('mainText')}>{mainText}</Text>}
        </Col>
      </Row>
      <Row>{children}</Row>
    </Container>
  </BeigeHeader>
);

BeigeHeaderContent.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]).isRequired,
  mainText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  children: childrenType,
  className: PropTypes.string,
  hasTorn: PropTypes.bool,
  hasCircles: PropTypes.bool,
};

export default BeigeHeaderContent;
